import { render, staticRenderFns } from "./index.vue?vue&type=template&id=648bdc7c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648bdc7c')) {
      api.createRecord('648bdc7c', component.options)
    } else {
      api.reload('648bdc7c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=648bdc7c&", function () {
      api.rerender('648bdc7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/agenda_pendentes/index.vue"
export default component.exports